const data = [
    {
        text: "Lancement du site Dawson's Creek",
        date: "27 Février 1999",
        category: {
            tag: "serie",
            color: "#018f69"
        },
        link: {
            url: "#",
            text: "en savoir plus"
        }
    },
    {
        text: "Lancement du site OC Attitude",
        date: "15 Décembre 2003",
        category: {
            tag: "serie",
            color: "#018f69"
        },
        link: {
            url: "http://the.oc.free.fr/",
            text: "en savoir plus"
        }
    },
    {
        text: "Lancement du blog TV Chronik",
        date: "17 Janvier 2006",
        category: {
            tag: "tv",
            color: "#ffdb14"
        },
        link: {
            url: "http://tvchronik.canalblog.com/",
            text: "en savoir plus"
        }
    },
    {
        text: "Lancement de tvchronik.com",
        date: "28 Juin 2007",
        category: {
            tag: "tv",
            color: "#ffdb14"
        },
        link: {
            url: "http://www.tvchronik.com/",
            text: "en savoir plus"
        }
    },
    {
        text: "Lancement du site It's TV News!",
        date: "25 Mars 2011",
        category: {
            tag: "tv",
            color: "#ffdb14"
        },
        link: {
            url: "https://www.itstvnews.com",
            text: "en savoir plus"
        }
    },
    {
        text: "It's TV News! devient SeriesTVnews",
        date: "3 Juin 2013",
        category: {
            tag: "tv",
            color: "#ffdb14"
        },
        link: {
            url: "https://www.itstvnews.com",
            text: "en savoir plus"
        }
    }
];

export default data;
